import BuildingEquipment from "./SurveyElements/Equipment/BuildingEquipment";

export default BuildingEquipment;
